import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Spinner, Container } from 'react-bootstrap';
import axios from 'axios';

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const REDIRECT_URI =
  process.env.REACT_APP_REDIRECT_URI ||
  'https://github.desuntechnologies.com/api/callback';

function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('AuthCallback: Starting callback handling');
        console.log('Current URL:', window.location.href);
        console.log('Location state:', location);

        // Function to store token and redirect
        const handleTokenAndRedirect = (token, userData) => {
          console.log('Storing token and user data');
          localStorage.setItem('github_token', token);
          if (userData) {
            localStorage.setItem(
              'github_user',
              JSON.stringify(userData)
            );
          }
          onLogin(token);
          console.log('Redirecting to dashboard');
          navigate('/dashboard', { replace: true });
        };

        // First check for token in URL hash
        if (window.location.hash) {
          console.log('Found hash in URL:', window.location.hash);
          const hashParams = new URLSearchParams(
            window.location.hash.substring(1)
          );
          const hashToken = hashParams.get('access_token');
          const userDataStr = hashParams.get('user_data');

          if (hashToken) {
            console.log('Found token in hash');
            let userData = null;
            if (userDataStr) {
              try {
                userData = JSON.parse(
                  decodeURIComponent(userDataStr)
                );
                console.log('Parsed user data:', userData);
              } catch (e) {
                console.error('Error parsing user data:', e);
              }
            }
            handleTokenAndRedirect(hashToken, userData);
            return;
          }
        }

        // If no token in hash, check for code in URL params
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');

        if (!code) {
          console.error('No code or token received in callback');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange code for token
        console.log('Exchanging code for token');
        const response = await axios.post(
          `${BACKEND_URL}/api/callback`,
          {
            code,
            redirect_uri: REDIRECT_URI,
          }
        );

        console.log('Token exchange response:', response.data);

        const { access_token, user } = response.data;
        if (!access_token) {
          throw new Error('No access token received');
        }

        handleTokenAndRedirect(access_token, user);
      } catch (error) {
        console.error('Auth error:', error);
        console.error('Error details:', error.response?.data);
        const errorMessage =
          error.response?.data?.error ||
          error.message ||
          'Authentication failed';
        alert(errorMessage);
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [location, navigate, onLogin]);

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="text-center">
        <Spinner animation="border" role="status" className="mb-3">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div>Completing authentication...</div>
      </div>
    </Container>
  );
}

export default AuthCallback;
